function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Spin } from '@nackle/paper';
import RecognitionService from '../../services/recognition';
import CMXService from '../../services/cmx';
export default class RewardChoiceLabel extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      loading: false,
      rewardChoices: []
    });
    _defineProperty(this, "loadRewardChoices", async () => {
      const {
        auth
      } = this.props;
      this.setState({
        loading: true
      });
      try {
        const recognitionService = new RecognitionService(auth.state);
        const rewardChoices = await recognitionService.searchRewardChoices();
        const cmxService = new CMXService(auth.state);
        const strings = await cmxService.getStringsWithAttributes('recognition', 'en-US', [{
          name: 'rewardChoice.name',
          attributes: {
            rewardChoiceId: rewardChoices.map(rc => rc.id)
          }
        }]);
        const stringsMap = {};
        if (Array.isArray(strings['rewardChoice.name'])) {
          strings['rewardChoice.name'].forEach(s => {
            stringsMap[s.stringAttributes.rewardChoiceId] = s;
          });
        }
        let rewardChoiceOptions = [];
        rewardChoices.forEach(rc => {
          if (stringsMap[rc.id]) {
            rewardChoiceOptions.push({
              id: rc.id,
              name: stringsMap[rc.id].value
            });
          }
        });
        rewardChoiceOptions = rewardChoiceOptions.sort((a, b) => a.name.localeCompare(b.name, undefined, {
          'sensitivity': 'base'
        }));
        this.setState({
          rewardChoices: rewardChoiceOptions,
          loading: false
        });
      } catch (error) {
        console.error(error);
        this.setState({
          loading: false
        });
      }
    });
  }
  componentDidMount() {
    this.loadRewardChoices();
  }
  render() {
    const {
      rewardChoiceId,
      ...props
    } = this.props;
    const {
      loading,
      rewardChoices
    } = this.state;
    props.auth = undefined;
    const rewardChoice = rewardChoices.find(rc => rc.id === rewardChoiceId);
    return /*#__PURE__*/React.createElement("span", props, rewardChoiceId && rewardChoice ? /*#__PURE__*/React.createElement("span", null, rewardChoice.name) : loading ? /*#__PURE__*/React.createElement(Spin, {
      size: "small"
    }) : /*#__PURE__*/React.createElement("span", null));
  }
}
//# sourceMappingURL=reward-choice-label.js.map